import { render } from "./Book_flights.vue?vue&type=template&id=45c7a9ca&scoped=true"
import script from "./Book_flights.vue?vue&type=script&lang=js"
export * from "./Book_flights.vue?vue&type=script&lang=js"

import "./Book_flights.vue?vue&type=style&index=0&id=45c7a9ca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c7a9ca"]])

export default __exports__